import type { GetServerSideProps, GetServerSidePropsResult } from 'next';

import LoginPageComponent from 'components/pagesComponents/auth/LoginPage';
import type { Props } from 'components/pagesComponents/auth/LoginPage/types';

import { wrapper } from 'redux-store';
import { setReferer, setRegion } from 'redux-store/slices/ui';
import getProfileThunk from 'redux-store/thunks/profile/getProfileThunk';
import getSocialProvidersThunk from 'redux-store/thunks/profile/getSocialProvidersThunk';

import { startSpanAndSetTransaction } from 'utils/APMService';
import { isRequestAuthenticated } from 'utils/auth/isRequestAuthenticated';
import getTranslate from 'utils/getTranslate';
import redirectAuthorizedUser from 'utils/redirectAuthorizedUser';

import { getSafeRedirect } from 'utils/getSafeRedirect';

import pagesUrls from '../../constants/pagesUrls';

export default LoginPageComponent;

export const getServerSideProps: GetServerSideProps =
  wrapper.getServerSideProps(
    store =>
      async (context): Promise<GetServerSidePropsResult<Props>> => {
        const endSpan = startSpanAndSetTransaction(context.resolvedUrl);
        const isAuthenticated = isRequestAuthenticated(context.req);
        const referer = context.req.headers.referer;

        const region = (context.req.headers['cf-ipcountry'] as string) || '';
        if (region) {
          await store.dispatch(setRegion(region));
        }

        store.dispatch(setReferer(referer || ''));

        if (isAuthenticated) {
          await store.dispatch(getProfileThunk(context));
        }

        const { profile: profileStore } = store.getState();

        if (profileStore.isAuthenticated) {
          const safeDestination = getSafeRedirect(context.query.destination as string);
          return {
            redirect: {
              destination:
                (safeDestination) ||
                pagesUrls.paymentHistory,
              permanent: false,
            },
          };
        }

        await store.dispatch(getSocialProvidersThunk());

        endSpan();

        return redirectAuthorizedUser<Props>(store.getState(), {
          ...(await getTranslate(context)),
        });
      },
  );
